import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rz9qg9uuan: FaireBrandEntity = {
  token: "b_rz9qg9uuan",
  type: "brand",
  name: "Coro Cora™",
  avatarUrl:
    "https://cdn.faire.com/fastly/d4252c24717bd23b9ece241dcf55d6b2f0a915410f67cef580d9a00f460a4baa.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d4252c24717bd23b9ece241dcf55d6b2f0a915410f67cef580d9a00f460a4baa.png",
  minimumOrderDollars: 300,
  rating: 4.9,
  reviewCount: 16,
  isTopShop: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
